<template>
	<slot name="default"></slot>
</template>
